import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1fb2cc16")
const _hoisted_1 = { class: "p-mt-3" }
const _hoisted_2 = { class: "p-text-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_4 = { class: "p-text-center" }
const _hoisted_5 = { class: "p-text-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"p-my-3 p-ml-3\" data-v-1fb2cc16><span class=\"p-d-inline-flex p-ai-center\" data-v-1fb2cc16><i class=\"pi pi-minus-circle av_icon--waiting\" data-v-1fb2cc16></i><span class=\"p-ml-3\" data-v-1fb2cc16>In attesa di conferma</span></span><span class=\"p-ml-3 p-d-inline-flex p-ai-center\" data-v-1fb2cc16><i class=\"pi pi-check-circle av_icon--confirmed\" data-v-1fb2cc16></i><span class=\"p-ml-3\" data-v-1fb2cc16>Disponibilità confermata</span></span></div>", 1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_WeekNavigator = _resolveComponent("WeekNavigator")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.taker && !_ctx.taker.zones?.length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!_ctx.taker?.zones?.length)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              closable: false,
              severity: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('taker_availabilities.no_zone_message')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 64))
    : (_ctx.taker)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("section", null, [
            _createVNode(_component_WeekNavigator, {
              modelValue: _ctx.range,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => (_ctx.range = $event)),
                _ctx.onUpdateRange
              ],
              disabled: !_ctx.taker.zones?.length
            }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
          ]),
          _createElementVNode("section", _hoisted_1, [
            _createVNode(_component_DataTable, {
              ref: "dt",
              loading: _ctx.requestPending,
              paginator: false,
              value: _ctx.shifts,
              class: "availability_datatable",
              responsiveLayout: "scroll",
              rowHover: "",
              showGridlines: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  class: "column-header-center",
                  header: "Fascia oraria"
                }, {
                  body: _withCtx(({data}) => [
                    _createElementVNode("div", _hoisted_2, [
                      _createTextVNode(_toDisplayString(data.name) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(data.start_time), 1),
                      _hoisted_3,
                      _createElementVNode("span", null, _toDisplayString(data.end_time), 1)
                    ])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    key: `day_${day}`,
                    class: "column-header-center"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.getWeekDay(day)), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.getFormattedDate(day)), 1)
                      ])
                    ]),
                    body: _withCtx(({data: shift}) => [
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.avExists(shift.id, day))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.avStatus(shift.id, day) === 20)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: "pi pi-check-circle av_icon--confirmed",
                                    onClick: ($event: any) => (_ctx.deleteAv(shift.id, day))
                                  }, null, 8, _hoisted_6)), [
                                    [_directive_tooltip, _ctx.$t('taker.av.confirmed')]
                                  ])
                                : _createCommentVNode("", true),
                              (_ctx.avStatus(shift.id, day) === 10)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 1,
                                    class: "pi pi-minus-circle av_icon--waiting",
                                    onClick: ($event: any) => (_ctx.deleteAv(shift.id, day))
                                  }, null, 8, _hoisted_7)), [
                                    [_directive_tooltip, _ctx.$t('taker.av.waiting')]
                                  ])
                                : _createCommentVNode("", true)
                            ], 64))
                          : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              class: "p-button-rounded",
                              icon: "pi pi-plus",
                              onClick: ($event: any) => (_ctx.addAvailability(shift.id, day))
                            }, null, 8, ["onClick"])), [
                              [_directive_tooltip, _ctx.$t('taker.add_availability')]
                            ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "value"]),
            _hoisted_8
          ])
        ], 64))
      : _createCommentVNode("", true)
}